export default __webpack_public_path__ + "static/media/Degradado.980a2674.mp4";